<template>
    <div>
        <vs-button class="bg-secondary-sh" @click="active=!active" size="mini">
            <font-awesome-icon icon="fa-solid fa-filter"/> 
            <span>{{ dataRowFilter.length ? dataRowFilter.length : 0}}</span>
        </vs-button>
        <!-- <px-filter-list 
            :active="active" 
            :dataList="dataList" 
            :dataRowFilter="dataRowFilter" 
            :name="name"
            @close-filter="handleCloseFilter()" 
            @check-all-filter="handleCheckAllFilter()"
        /> -->

        <!--  -->
        <px-modal
            v-show="active"
            @verModal="active = $event"
            idModal= 'modalFiltroTabla'
            :textHeader='name'
            modalWidth='400px'
        >
        <div class="w-100 d-flex justify-content-end">
            <vs-button class="btn-transparent p-0 closeStyle" @click="active=false">x</vs-button>  
        </div>
            <!-- contenido -->
            <div class="center con-checkbox pb-2">
                <vs-checkbox class="check-primary" v-for="(data) in dataList" :val="data" v-model="dataRowFilter" :key="data">
                {{data}}
                </vs-checkbox>
            </div>  
            <vs-button class="btn-tertiary-variant m-0 w-100" @click="active=false">Cerrar</vs-button>          
        </px-modal>


    </div>
</template>
<script>
    import PxFilterList from '@/components/table/components/PxFilterList.vue'
    import PxModal from '@/components/PxModal.vue'
    export default {
        components: { PxFilterList, PxModal },
        props:{
            dataList:{
                default: () => [],
                type: Array
            },
            dataRowFilter:{
                default: () => [],
                type: Array
            },
            name:{
                default: null,
                type: String,
            },
        },
        data(){
            return{
                active:false,
                
                // verModal: false,
            }
        },
        methods:{
            handleCloseFilter(){
                this.active = false
                // this.$emit('set-filter-data',this.dataRowFilter,this.indexColumn)
            },
            handleCheckAllFilter(){
                this.dataRowFilter = [...this.$vs.checkAll(this.dataRowFilter, this.dataList)]
            }
        },
        created(){
            //Buscar solo seleccionados
            // this.dataRowFilter=this.dataList
        }
    }
</script>
<style coped>
.closeStyle{
    margin-top:-84px !important; 
    margin-bottom:10px !important; 
    color:white !important; 
    font-size: 1rem !important; 
    font-weight:bold !important;
}
</style>